import { render, staticRenderFns } from "./DialogPreviewFull.vue?vue&type=template&id=06aae580"
import script from "./DialogPreviewFull.vue?vue&type=script&lang=js"
export * from "./DialogPreviewFull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports